<!-- 项目分析 -->
<template>
  <div class="content">
    <el-button type="text"
               icon="el-icon-arrow-left"
               style="color:#89909d"
               @click="back()">返回</el-button>
    <div v-if="!this.sampleListParameter.projectId"
         style="display:flex;justify-content:end;">
      <div>
        <el-button type="primary"
                   icon="el-icon-view"
                   v-if="analysisRes1"
                   @click="addProjectAnalysis()">分析结果</el-button>
        <el-button type="warning"
                   icon="el-icon-download"
                   @click="downloadProjectAnalysis(analysisResList.id)">下载分析结果</el-button>
      </div>
    </div>
    <div class="top"
         v-if="this.sampleListParameter.projectId">
      <div class="title">
        <div class="name">项目名称：{{projectName}}</div>
        <div class="text">项目周期：2025-07-2025-09</div>
      </div>
      <div>
        <el-button type="success"
                   icon="el-icon-upload2"
                   @click="gotoTransfer(2)">上传表格</el-button>
        <el-button type="info"
                   icon="el-icon-folder-checked"
                   @click="gotoTransfer(3)">上传原始数据</el-button>
        <el-button type="warning"
                   icon="el-icon-download"
                   @click="downloadOriginalData()">下载原始数据</el-button>
        <el-button type="primary"
                   icon="el-icon-view"
                   v-if="analysisRes1"
                   @click="addProjectAnalysis()">分析结果</el-button>
        <el-button type="primary"
                   icon="el-icon-view"
                   v-if="analysisRes2"
                   @click="addProjectAnalysis2()">分析结果</el-button>
        <el-button type="primary"
                   icon="el-icon-view"
                   v-if="analysisRes3"
                   @click="addProjectAnalysis3()">分析结果</el-button>
        <el-button type="warning"
                   icon="el-icon-download"
                   @click="downloadProjectAnalysis(analysisResList.id)">下载分析结果</el-button>
      </div>

      <!-- 分析结果 -->
      <el-dialog title="分析结果"
                 :visible.sync="analysisResDialogVisible"
                 width="30%"
                 :close-on-press-escape="false">
        <div>
          <el-button style="background-color: #145fad; color: white; border-color: #fff;"
                     icon="el-icon-view"
                     @click="openFullScreen1()">聚合分析</el-button>
          <el-button style="background-color: #ebb563; color: white; border-color: #fff;"
                     icon="el-icon-view"
                     @click="openResponseDialogVisible()">响应曲线</el-button>
          <el-button style="background-color: #85ce61; color: white; border-color: #fff;"
                     icon="el-icon-view"
                     @click="openModuleDialogVisible()">组间差异</el-button>
        </div>

      </el-dialog>
      <el-dialog title="响应曲线"
                 :visible.sync="responseDialogVisible"
                 width="30%"
                 :close-on-press-escape="false">
        <div>
          <el-button style="background-color: #145fad; color: white; border-color: #fff;"
                     icon="el-icon-view"
                     @click="openFullScreen2()">20mM</el-button>
          <el-button style="background-color: #ebb563; color: white; border-color: #fff;"
                     icon="el-icon-view"
                     @click="openFullScreen3()">60mM</el-button>
        </div>
      </el-dialog>
      <!-- 响应曲线(20mM) -->
      <el-dialog title="响应曲线(20mM)"
                 :visible.sync="image1"
                 width="30%"
                 :close-on-press-escape="false">
        <div v-if="analysisRes2"
             style="text-align: center;">
          <el-image style="width: 300px; height: 300px"
                    :src="imageSrc1"
                    :preview-src-list="srcList1"></el-image>
        </div>
        <div v-else
             style="text-align: center;">
          <el-image style="width: 300px; height: 300px"
                    :src="imageSrc11"
                    :preview-src-list="srcList11"></el-image>
        </div>
      </el-dialog>
      <!-- 响应曲线(60mM) -->
      <el-dialog title="响应曲线(60mM)"
                 :visible.sync="image2"
                 width="30%"
                 :close-on-press-escape="false">
        <div v-if="analysisRes2"
             style="text-align: center;">
          <el-image style="width: 300px; height: 300px"
                    :src="imageSrc2"
                    :preview-src-list="srcList2"></el-image>
        </div>
        <div v-else
             style="text-align: center;">
          <el-image style="width: 300px; height: 300px"
                    :src="imageSrc22"
                    :preview-src-list="srcList22"></el-image>
        </div>
      </el-dialog>
      <el-dialog title="组间差异"
                 :visible.sync="moduleDialogVisible"
                 width="30%"
                 :close-on-press-escape="false">
        <div>
          <el-button style="background-color: #145fad; color: white; border-color: #fff;"
                     icon="el-icon-view"
                     @click="openFullScreen4()">NSFR Index 1</el-button>
          <el-button style="background-color: #ebb563; color: white; border-color: #fff;"
                     icon="el-icon-view"
                     @click="openFullScreen5()">NSFR Index 2</el-button>
        </div>
      </el-dialog>

      <!-- 组间差异(NSFR Index 1) -->
      <el-dialog title="组间差异(NSFR Index 1)"
                 :visible.sync="image3"
                 width="30%"
                 :close-on-press-escape="false">
        <div v-if="analysisRes2"
             style="text-align: center;">
          <el-image style="width: 300px; height: 300px"
                    :src="imageSrc3"
                    :preview-src-list="srcList3"></el-image>
        </div>
        <div v-else
             style="text-align: center;">
          <el-image style="width: 300px; height: 300px"
                    :src="imageSrc33"
                    :preview-src-list="srcList33"></el-image>
        </div>
      </el-dialog>
      <!-- 响应曲线(NSFR Index 2) -->
      <el-dialog title="组间差异(NSFR Index 2)"
                 :visible.sync="image4"
                 width="30%"
                 :close-on-press-escape="false">
        <div v-if="analysisRes2"
             style="text-align: center;">
          <el-image style="width: 300px; height: 300px"
                    :src="imageSrc4"
                    :preview-src-list="srcList4"></el-image>
        </div>
        <div v-else
             style="text-align: center;">
          <el-image style="width: 300px; height: 300px"
                    :src="imageSrc44"
                    :preview-src-list="srcList44"></el-image>
        </div>
      </el-dialog>

      <!-- <div class="analyse"
           @click="openAnalyse(1)"
           v-if="isAnalysisResult">
        <div class="left">
          <img src="@/assets/images/analyse.png"
               alt=""
               class="img">
        </div>
        <div class="right">
          <div class="title"> 项目分析</div>
          <div class="text">对当前项目进行结果分析</div>
        </div>
      </div>
      <div class="analyse2"
           @click="openAnalyse(2)"
           v-else>
        <div class="left">
          <img src="@/assets/images/analyse2.png"
               alt=""
               class="img">
        </div>
        <div class="right">
          <div class="title">分析结果</div>
          <div class="text">查看或下载当前项目分析结果</div>
        </div>
      </div> -->
    </div>
    <!-- 分析结果 -->
    <!-- <el-dialog title="分析结果"
               :visible.sync="analysisResDialogVisible"
               width="30%">
      <div v-if="!projectAnalysis">
        <el-form label-position="top"
                 label-width="80px"
                 :inline="true"
                 :model="analysisResList">
          <el-form-item label="分析名称：">
            <div>{{analysisResList.name}}</div>
          </el-form-item>
          <el-form-item label="时间：">
            <div>{{analysisResList.time}}</div>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button style="background-color: #145fad; color: white; border-color: #fff;"
                     @click="downloadProjectAnalysis(analysisResList.id)"><i class="el-icon-download"></i>下载结果文件</el-button>
        </span>
      </div>
      <div v-else>
        <span slot="footer"
              class="dialog-footer">
          <el-button style="background-color: #145fad; color: white; border-color: #fff;"
                     @click="addProjectAnalysis()"><i class="el-icon-plus"></i>添加项目分析</el-button>
        </span>
      </div>
    </el-dialog> -->

    <el-card class="box-card">
      <el-button icon="el-icon-full-screen"
                 style="color:#145fad;border-color: #145fad"
                 @click="openScreenDialog()"> 筛选</el-button>
      <el-button icon="el-icon-download"
                 v-if="this.sampleListParameter.projectId"
                 style="color:#145fad;border-color: #145fad"
                 @click="exportSample()">导出</el-button>

      <!-- 筛选 -->
      <el-dialog :visible.sync="screenDialogVisible"
                 title="筛选表格"
                 width="70%">
        <el-form label-position="top"
                 label-width="80px"
                 :inline="true"
                 :model="sampleListParameter">
          <el-form-item label="诊断结果">
            <el-select v-model="sampleListParameter.diagnosisList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择诊断结果">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="其他疾病情况">
            <el-input v-model="sampleListParameter.otherMedicalConditions"
                      clearable
                      placeholder="请输入其他疾病情况"></el-input>
          </el-form-item>
          <el-form-item label="烟酸检测日期">
            <el-date-picker v-model="NSFRTestDate"
                            @change="changeNSFRTestDate"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="烟酸测定值">
            <el-select v-model="sampleListParameter.nsfrScoreList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择烟酸测定值">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="烟酸风险等级">
            <el-select v-model="sampleListParameter.nsfrRiskList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择烟酸风险等级">
              <el-option v-for="item in riskOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别">
            <el-select v-model="sampleListParameter.gender"
                       clearable
                       placeholder="请选择性别">
              <el-option label="男"
                         :value=0></el-option>
              <el-option label="女"
                         :value=1></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄">
            <el-select v-model="sampleListParameter.ageList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择年龄">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身高(cm)">
            <el-select v-model="sampleListParameter.heightList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择身高(cm)">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>

          </el-form-item>
          <el-form-item label="体重(KG)">
            <el-select v-model="sampleListParameter.weightList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择体重(KG)">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="抽烟情况">
            <el-select v-model="sampleListParameter.smokingStatusList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择抽烟情况">
              <el-option v-for="item in smokingOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="饮酒情况">
            <el-select v-model="sampleListParameter.alcoholStatusList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择饮酒情况">
              <el-option v-for="item in alcoholOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文化程度">
            <el-select v-model="sampleListParameter.educationLevelList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择文化程度">
              <el-option v-for="item in cultureOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="受教育年限">
            <el-select v-model="sampleListParameter.yearsOfEducationList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择受教育年限">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="病程是否首发">
            <el-select v-model="sampleListParameter.firstOnset"
                       clearable
                       placeholder="请选择病程是否首发">
              <el-option label="否"
                         :value=0></el-option>
              <el-option label="是"
                         :value=1></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="首次发病年龄">
            <el-select v-model="sampleListParameter.ageAtOnsetList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择首次发病年龄">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="病程">
            <el-select v-model="sampleListParameter.diseaseDurationList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择病程">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分组名称">
            <el-select v-model="sampleListParameter.groupList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择输入分组名称">
              <el-option v-for="(item, idx) in groupOptions"
                         :key="item.value + '_' + idx"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button style="background-color: #145fad; color: white; border-color: #fff;"
                     icon="el-icon-check"
                     @click="openFullScreen1()">提交</el-button>
        </span>
      </el-dialog>
    </el-card>
    <el-card class="box-card">
      <template v-if="!pageLoading && total > 0">
        <div class="table-scroll">
          <el-table :data="sampleList"
                    style="width: 100%"
                    :fit="false"
                    v-loading="tableLoading"
                    element-loading-text="加载中..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 255, 255, 0.6)">
            <template v-for="col in sampleColumnResList">
              <el-table-column :key="col.name"
                               :prop="col.name"
                               :label="col.nameChinese"
                               align="center"
                               :min-width="getMinWidth(col.nameChinese)"
                               show-overflow-tooltip
                               v-if="col.show">
                <template slot-scope="scope">
                  <span v-if="col.name === 'gender'">{{scope.row.gender==0?'男':scope.row.gender==1?'女':''}}</span>
                  <span v-else-if="col.name === 'firstOnset'">{{scope.row.firstOnset==0?'否':scope.row.firstOnset==1?'是':''}}</span>
                  <span v-else-if="col.name === 'nsfrtestDate' || col.name === 'NSFRTestDate' || col.nameChinese === '烟酸检测日期'">{{ formatDate(scope.row, null, scope.row[col.name]) }}</span>
                  <span v-else-if="col.name === 'groupList'">{{ formatGroupList(scope.row, null, scope.row.groupList) }}</span>
                  <span v-else>{{ scope.row[col.name] }}</span>
                </template>
              </el-table-column>
            </template>
            <el-table-column label="操作"
                             width="110"
                             fixed="right"
                             align="center"
                             v-if="this.sampleListParameter.projectId">
              <template v-slot="{row}">
                <el-button-group>
                  <el-button type="primary"
                             size="mini"
                             icon="el-icon-edit"
                             @click="openEditDialog(row)"></el-button>
                  <el-button type="danger"
                             size="mini"
                             icon="el-icon-delete"
                             @click="delDialog(row)"></el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-row class="pagination"
                v-if="total > 0">
          <pagination :total="total"
                      :page.sync="sampleListParameter.pageNum"
                      :limit.sync="sampleListParameter.pageSize"
                      @pagination="getSampleList" />
        </el-row>
      </template>
      <template v-else-if="!pageLoading && !tableLoading && total === 0">
        <div class="empty-wrap">
          <i class="el-icon-info"></i>
          <span class="text">当前项目暂无样本数据</span>
        </div>
      </template>

      <!-- 修改样本 -->
      <el-dialog :visible.sync="editSampleDialogVisible"
                 title="修改样本"
                 width="70%">
        <el-form label-position="top"
                 label-width="80px"
                 :inline="true"
                 :model="modifySampleList">
          <el-form-item label="诊断结果">
            <el-input v-model="modifySampleList.diagnosis"
                      placeholder="请输入诊断结果"></el-input>
          </el-form-item>
          <el-form-item label="其他疾病情况">
            <el-input v-model="modifySampleList.otherMedicalConditions"
                      placeholder="请输入其他疾病情况"></el-input>
          </el-form-item>
          <el-form-item label="烟酸检测日期">
            <el-date-picker type="date"
                            placeholder="请选择烟酸检测日期"
                            v-model="modifySampleList.nsfrtestDate"
                            style="width: 100%;"></el-date-picker>
          </el-form-item>
          <el-form-item label="烟酸测定值">
            <el-input v-model="modifySampleList.nsfrscore"
                      placeholder="请输入烟酸测定值"></el-input>
          </el-form-item>
          <el-form-item label="烟酸风险等级">
            <el-input v-model="modifySampleList.nsfrrisk"
                      placeholder="请输入烟酸风险等级"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-select v-model="modifySampleList.gender"
                       placeholder="请选择性别">
              <el-option label="男"
                         :value=0></el-option>
              <el-option label="女"
                         :value=1></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄">
            <el-input v-model="modifySampleList.age"
                      placeholder="请输入年龄"></el-input>
          </el-form-item>
          <el-form-item label="身高(cm)">
            <el-input v-model="modifySampleList.height"
                      placeholder="请输入身高"></el-input>
          </el-form-item>
          <el-form-item label="体重(KG)">
            <el-input v-model="modifySampleList.weight"
                      placeholder="请输入体重"></el-input>
          </el-form-item>
          <el-form-item label="抽烟情况">
            <el-input v-model="modifySampleList.smokingStatus"
                      placeholder="请输入抽烟情况"></el-input>
          </el-form-item>
          <el-form-item label="饮酒情况">
            <el-input v-model="modifySampleList.alcoholStatus"
                      placeholder="请输入饮酒情况"></el-input>
          </el-form-item>
          <el-form-item label="文化程度">
            <el-input v-model="modifySampleList.educationLevel"
                      placeholder="请输入文化程度"></el-input>
          </el-form-item>
          <el-form-item label="受教育年限">
            <el-input v-model="modifySampleList.yearsOfEducation"
                      placeholder="请输入受教育年限"></el-input>
          </el-form-item>
          <el-form-item label="病程是否首发">
            <el-select v-model="modifySampleList.firstOnset"
                       placeholder="请选择病程是否首发">
              <el-option label="否"
                         :value=0></el-option>
              <el-option label="是"
                         :value=1></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="首次发病年龄">
            <el-input v-model="modifySampleList.ageAtOnset"
                      placeholder="请输入首次发病年龄"></el-input>
          </el-form-item>
          <el-form-item label="病程">
            <el-input v-model="modifySampleList.diseaseDuration"
                      placeholder="请输入病程"></el-input>
          </el-form-item>
          <el-form-item label="家族史">
            <el-input v-model="modifySampleList.familyHistory"
                      placeholder="请输入家族史"></el-input>
          </el-form-item>
          <el-form-item label="用药情况">
            <el-input v-model="modifySampleList.medicationStatus"
                      placeholder="请输入用药情况"></el-input>
          </el-form-item>
          <el-form-item label="分组名称">
            <el-select v-model="modifySampleList.groupList"
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="请选择分组名称">
              <el-option v-for="(item, idx) in groupOptions"
                         :key="item.value + '_' + idx"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户ID">
            <el-input v-model="modifySampleList.userId"
                      placeholder="请输入用户ID"></el-input>
          </el-form-item>
          <el-form-item label="烟酸检测设备">
            <el-input v-model="modifySampleList.nsfrtestDevice"
                      placeholder="请输入烟酸检测设备"></el-input>
          </el-form-item>
          <el-form-item label="烟酸检测时长">
            <el-input v-model="modifySampleList.nsfrtestDuration"
                      placeholder="请输入烟酸检测时长"></el-input>
          </el-form-item>
          <el-form-item label="文件路径id">
            <el-input v-model="modifySampleList.fileId"
                      placeholder="请输入文件路径id"></el-input>
          </el-form-item>

        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button style="background-color: #145fad; color: white; border-color: #fff;"
                     icon="el-icon-check"
                     @click="submitModifySample()">提交</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'
// import echarts from 'echarts'
import Pagination from '@/components/Pagination/index.vue'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      analysisRes1: true,
      analysisRes2: false,
      analysisRes3: false,
      image1: false,
      image2: false,
      image3: false,
      image4: false,
      imageSrc1: require('@/assets/images/20mM.png'),
      imageSrc2: require('@/assets/images/60mM.png'),
      imageSrc3: require('@/assets/images/NSFR Index 1.png'),
      imageSrc4: require('@/assets/images/NSFR Index 2.png'),
      srcList1: [require('@/assets/images/20mM.png')],
      srcList2: [require('@/assets/images/60mM.png')],
      srcList3: [require('@/assets/images/NSFR Index 1.png')],
      srcList4: [require('@/assets/images/NSFR Index 2.png')],

      imageSrc11: require('@/assets/images/NSFR_20mM_20250903_234329.png'),
      imageSrc22: require('@/assets/images/NSFR_60mM_20250903_234344.png'),
      imageSrc33: require('@/assets/images/NSFR Index 1_20250903_234144.png'),
      imageSrc44: require('@/assets/images/NSFR Index 2_20250903_234223.png'),
      srcList11: [require('@/assets/images/NSFR_20mM_20250903_234329.png')],
      srcList22: [require('@/assets/images/NSFR_60mM_20250903_234344.png')],
      srcList33: [require('@/assets/images/NSFR Index 1_20250903_234144.png')],
      srcList44: [require('@/assets/images/NSFR Index 2_20250903_234223.png')],
      fullscreenLoading: false,
      projectName: '',
      projectId: '',
      options: [],
      groupOptions: [],
      cultureOptions: [
        {
          value: '未受过正式教育',
          label: '未受过正式教育'
        },
        {
          value: '小学',
          label: '小学'
        },
        {
          value: '初中',
          label: '初中'
        },
        {
          value: '高中',
          label: '高中'
        },
        {
          value: '中专∪职高∪技校',
          label: '中专∪职高∪技校'
        },
        {
          value: '专科',
          label: '专科'
        },
        {
          value: '本科',
          label: '本科'
        },
        {
          value: '硕士',
          label: '硕士'
        },
        {
          value: '博士',
          label: '博士'
        }
      ],
      smokingOptions: [
        {
          value: '从不',
          label: '从不'
        },
        {
          value: '曾经',
          label: '曾经'
        },
        {
          value: '偶尔',
          label: '偶尔'
        },
        {
          value: '经常',
          label: '经常'
        }
      ],
      alcoholOptions: [
        {
          value: '从不',
          label: '从不'
        },
        {
          value: '曾经',
          label: '曾经'
        },
        {
          value: '偶尔',
          label: '偶尔'
        },
        {
          value: '经常',
          label: '经常'
        }
      ],
      riskOptions: [
        {
          value: '无风险',
          label: '无风险'
        },
        {
          value: '低风险',
          label: '低风险'
        },
        {
          value: '中风险',
          label: '中风险'
        },
        {
          value: '高风险',
          label: '高风险'
        }
      ],
      NSFRTestDate: '',
      sampleListParameter: {
        pageSize: 10,
        pageNum: 1,
        projectId: [],
        diagnosisList: [],
        otherMedicalConditions: '',
        startNFSRTestDate: '',
        endNFSRTestDate: '',
        nsfrScoreList: [],
        nsfrRiskList: [],
        gender: '',
        ageList: [],
        heightList: [],
        weightList: [],
        smokingStatusList: [],
        alcoholStatusList: [],
        educationLevelList: [],
        yearsOfEducationList: [],
        firstOnset: '',
        ageAtOnsetList: [],
        diseaseDurationList: [],
        groupList: []
      },
      sampleList: [],
      sampleColumnResList: [],
      total: 0,
      tableLoading: false,
      pageLoading: true,
      editSampleDialogVisible: false,
      screenDialogVisible: false,
      modifySampleList: {
        id: '',
        diagnosis: '',
        otherMedicalConditions: '',
        nsfrtestDate: '',
        nsfrscore: '',
        nsfrrisk: '',
        gender: '',
        age: '',
        height: '',
        weight: '',
        smokingStatus: '',
        alcoholStatus: '',
        educationLevel: '',
        yearsOfEducation: '',
        firstOnset: '',
        ageAtOnset: '',
        diseaseDuration: '',
        familyHistory: '',
        medicationStatus: '',
        groupList: [],
        fileId: '',
        userId: '',
        nsfrtestDevice: '',
        nsfrtestDuration: ''
      },
      analysisResDialogVisible: false,
      moduleDialogVisible: false,
      responseDialogVisible: false,
      projectAnalysis: false,
      analysisResList: {},
      isAnalysisResult: false
    }
  },
  async mounted() {
    const loading = this.$loading({
      lock: true,
      text: '页面加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.2)'
    })
    this.projectName = this.$route.query.name
    this.sampleListParameter.projectId = this.$route.query.projectId
    if (this.$route.query.projectId == 'PRIFJHE6JDEHDOS') {
      this.analysisRes2 = true
      this.analysisRes3 = false
      this.analysisRes1 = false
    } else if (this.$route.query.projectId == 'PRI4K40DJ93JF0D') {
      this.analysisRes3 = true
      this.analysisRes2 = false
      this.analysisRes1 = false
    } else {
      this.analysisRes3 = false
      this.analysisRes2 = false
      this.analysisRes1 = true
    }
    try {
      await Promise.all([this.getProjectAnalysisInfo(), this.getSampleList()])
    } finally {
      loading.close()
      this.pageLoading = false
    }
  },

  methods: {
    getMinWidth(name) {
      if (!name) return '80'
      // 预估每个汉字宽度 + padding
      return name.length * 15 + 30 + ''
    },
    openScreenDialog() {
      this.screenDialogVisible = true
      this.getGroupListOptions()
    },
    async getGroupListOptions() {
      const { data: res } = await this.$http.get('/brain/group/getGroupList')
      if (res.code == 200) {
        let list = []
        if (Array.isArray(res.data) && res.data.length > 0) {
          if (typeof res.data[0] === 'string') {
            list = res.data.map((item) => ({
              value: item,
              label: item
            }))
          } else if (typeof res.data[0] === 'object') {
            list = res.data.map((item) => ({
              value: item.name || item.groupName || item.value,
              label: item.name || item.groupName || item.label || String(item.value || '')
            }))
          }
        }
        const seen = new Set()
        this.groupOptions = list.filter((opt) => {
          const v = String(opt.value || '')
          if (!v) return false
          if (seen.has(v)) return false
          seen.add(v)
          return true
        })
      }
    },
    openResponseDialogVisible() {
      this.analysisResDialogVisible = false
      this.responseDialogVisible = true
    },
    openModuleDialogVisible() {
      this.analysisResDialogVisible = false
      this.moduleDialogVisible = true
    },
    openFullScreen1() {
      const loading = this.$loading({
        lock: true,
        text: '聚合分析中！',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
      }, 5000)
    },
    openFullScreen2() {
      const loading = this.$loading({
        lock: true,
        text: '响应曲线图片生成中!',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
        this.image1 = true
      }, 2000)
    },
    openFullScreen3() {
      const loading = this.$loading({
        lock: true,
        text: '响应曲线图片生成中!',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
        this.image2 = true
      }, 2000)
    },
    openFullScreen4() {
      const loading = this.$loading({
        lock: true,
        text: '组间差异图片生成中!',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
        this.image3 = true
      }, 2000)
    },
    openFullScreen5() {
      const loading = this.$loading({
        lock: true,
        text: '组间差异图片生成中!',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
        this.image4 = true
      }, 2000)
    },
    changeNSFRTestDate(value) {
      if (value) {
        this.sampleListParameter.startNSFRTestDate = moment(value[0]).format('YYYY-MM-DD')
        this.sampleListParameter.endNSFRTestDate = moment(value[1]).format('YYYY-MM-DD')
      } else {
        this.sampleListParameter.startNSFRTestDate = ''
        this.sampleListParameter.endNSFRTestDate = ''
      }
    },

    formatDate(row, column, cellValue) {
      if (!cellValue) return ''
      return moment(cellValue).format('YYYY-MM-DD')
    },
    formatGroupList(row, column, cellValue) {
      if (Array.isArray(cellValue)) {
        return cellValue.join('/')
      }
      if (Array.isArray(row.groupList)) {
        return row.groupList.join('/')
      }
      return cellValue || ''
    },
    gotoTransfer(type) {
      this.$router.push({ path: '/transfer', query: { type: type, projectId: this.sampleListParameter.projectId } })
    },
    // 返回
    back() {
      const q = this.$route.query || {}
      if (q.tab) {
        this.$router.push({ path: '/managementItem', query: { tab: q.tab, page: q.page } })
      } else {
        this.$router.back()
      }
    },
    // 添加项目分析
    async addProjectAnalysis() {
      const startedAt = Date.now()
      const loading = this.$loading({
        lock: true,
        text: '分析中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      try {
        await this.$nextTick()
        const { data: res } = await this.$http.get('/brain/project_analysis/addProjectAnalysis', { params: { projectId: this.sampleListParameter.projectId } })
        if (res && res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg || '分析请求已提交'
          })
        } else {
          this.$message.error((res && res.msg) || '分析失败')
        }
      } catch (e) {
        this.$message.error('分析失败')
      } finally {
        const elapsed = Date.now() - startedAt
        if (elapsed < 300) {
          await new Promise((resolve) => setTimeout(resolve, 300 - elapsed))
        }
        loading.close()
      }
    },
    async addProjectAnalysis2() {
      this.analysisResDialogVisible = true
    },
    async addProjectAnalysis3() {
      this.analysisResDialogVisible = true
    },
    // 打开分析结果对话框
    openAnalyse(type) {
      if (type == 1) {
        this.projectAnalysis = true
      } else {
        this.projectAnalysis = false
      }
      this.analysisResDialogVisible = true
    },
    async getProjectAnalysisInfo() {
      const { data: res } = await this.$http.get('/brain/project_analysis/getProjectAnalysisInfo', { params: { projectId: this.sampleListParameter.projectId } })
      if (res.data) {
        console.log(res.data)
        this.analysisResList = res.data
        this.isAnalysisResult = false
      } else {
        this.isAnalysisResult = true
      }
    },
    async downloadProjectAnalysis(id) {
      const loading = this.$loading({
        lock: true,
        text: '正在导出数据，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      try {
        const response = await this.$http.get('/brain/project_analysis/downloadProjectAnalysis', {
          params: { projectAnalysisId: id },
          responseType: 'blob'
        })
        const contentType = response.headers && response.headers['content-type'] ? response.headers['content-type'] : ''
        if (contentType.includes('application/json')) {
          const text = await response.data.text()
          const json = JSON.parse(text || '{}')
          this.$message.error(json.msg || '导出失败')
          return
        }
        const blob = new Blob([response.data])
        let filename = `${id}分析结果.xlsx`
        const disposition = response.headers && response.headers['content-disposition']
        if (disposition) {
          const match = disposition.match(/filename\\*=UTF-8''([^;]+)|filename=\"?([^\";]+)\"?/i)
          const encoded = (match && (match[1] || match[2])) || ''
          if (encoded) filename = decodeURIComponent(encoded)
        }
        const a = document.createElement('a')
        a.style.display = 'none'
        a.download = filename
        a.href = URL.createObjectURL(blob)
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(a.href)
        this.$message({
          type: 'success',
          message: '开始下载!'
        })
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        loading.close()
      }
    },
    async downloadOriginalData() {
      const loading = this.$loading({
        lock: true,
        text: '正在下载原始数据，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      try {
        const response = await this.$http.get('/brain/sampleFile/exportSampleFile', {
          params: { projectId: this.sampleListParameter.projectId },
          responseType: 'blob'
        })
        const contentType = response.headers && response.headers['content-type'] ? response.headers['content-type'] : ''
        if (contentType.includes('application/json')) {
          const text = await response.data.text()
          let json = {}
          try {
            json = JSON.parse(text || '{}')
          } catch (e) {
            json = {}
          }
          const msg = (json && json.msg) || ''
          const code = json && typeof json.code !== 'undefined' ? json.code : undefined
          const isNoData = code === 204 || code === 404 || !msg || /未找到|不存在|无有效|没有/.test(msg)
          this.$message.error(isNoData ? '未找到原始数据' : msg || '下载失败')
          return
        }
        if (contentType.includes('text/') || contentType.includes('application/xml')) {
          const text = await response.data.text()
          const isNoData = !text || /未找到|不存在|无有效|没有/.test(text)
          this.$message.error(isNoData ? '未找到原始数据' : text)
          return
        }
        const blob = new Blob([response.data], { type: contentType || 'application/zip' })
        if (!blob || blob.size === 0) {
          this.$message.error('未找到原始数据')
          return
        }
        const rawProjectName = typeof this.projectName === 'string' ? this.projectName : ''
        const safeProjectName = (rawProjectName || '项目')
          .trim()
          .replace(/[\\/:*?"<>|]/g, '_')
          .replace(/\s+/g, ' ')
        const filename = `TYNSR_${safeProjectName}.zip`
        const a = document.createElement('a')
        a.style.display = 'none'
        a.download = filename
        a.href = URL.createObjectURL(blob)
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(a.href)
        document.body.removeChild(a)
        this.$message({
          type: 'success',
          message: '开始下载!'
        })
      } catch (e) {
        const status = e && e.response ? e.response.status : undefined
        if (status === 404 || status === 204) {
          this.$message.error('未找到原始数据')
        } else {
          this.$message.error('下载失败')
        }
      } finally {
        loading.close()
      }
    },
    openFullScreen1() {
      this.tableLoading = true
      this.getSampleList()
    },
    async getSampleList() {
      this.tableLoading = true
      try {
        const { data: res } = await this.$http.post('/brain/sample/getSampleList', this.sampleListParameter)
        if (res.code == 200) {
          if (res.data.sampleDataResList) {
            this.sampleList = res.data.sampleDataResList.list
            this.total = res.data.sampleDataResList.total
          }
          if (res.data.sampleColumnResList) {
            this.sampleColumnResList = res.data.sampleColumnResList
          }
          this.screenDialogVisible = false
        } else {
          this.$message.error(res.msg)
        }
      } finally {
        this.tableLoading = false
      }
    },
    // 删除对话框
    delDialog(row) {
      this.$confirm(`此操作将删除样本编号为${row.number}的样本, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delSample(row.id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 确认删除
    async delSample(id) {
      const { data: res } = await this.$http.get('/brain/sample/delSample', { params: { sampleId: id } })
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.getSampleList()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 导出样本
    async exportSample() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出数据，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      try {
        const response = await this.$http.post('/brain/sample/exportSample', this.sampleListParameter, { responseType: 'blob' })
        const contentType = response.headers && response.headers['content-type'] ? response.headers['content-type'] : ''
        if (contentType.includes('application/json')) {
          const text = await response.data.text()
          const json = JSON.parse(text || '{}')
          this.$message.error(json.msg || '导出失败')
          return
        }
        const blob = new Blob([response.data])
        const rawProjectName = typeof this.projectName === 'string' ? this.projectName : ''
        const safeProjectName = (rawProjectName || '项目')
          .trim()
          .replace(/[\\/:*?"<>|]/g, '_')
          .replace(/\s+/g, ' ')
        let a = document.createElement('a')
        a.style.display = 'none'
        a.download = `TYNSR_${safeProjectName}.xlsx`
        a.href = URL.createObjectURL(blob)
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(a.href)
        this.$message({
          type: 'success',
          message: '开始下载!'
        })
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        loading.close()
      }
    },
    openEditDialog(row) {
      this.getGroupListOptions()
      this.editSampleDialogVisible = true
      this.modifySampleList.id = row.id
      this.modifySampleList.diagnosis = row.diagnosis
      this.modifySampleList.nsfrtestDate = row.NSFRTestDate || row.nsfrTestDate || row.nsfrtestDate
      this.modifySampleList.otherMedicalConditions = row.otherMedicalConditions
      this.modifySampleList.nsfrscore = row.NSFRScore || row.nsfrScore || row.nsfrscore
      this.modifySampleList.nsfrrisk = row.NSFRRisk || row.nsfrRisk || row.nsfrrisk
      this.modifySampleList.gender = row.gender
      this.modifySampleList.age = row.age
      this.modifySampleList.height = row.height
      this.modifySampleList.weight = row.weight
      this.modifySampleList.smokingStatus = row.smokingStatus
      this.modifySampleList.alcoholStatus = row.alcoholStatus
      this.modifySampleList.educationLevel = row.educationLevel
      this.modifySampleList.yearsOfEducation = row.yearsOfEducation
      this.modifySampleList.firstOnset = row.firstOnset
      this.modifySampleList.ageAtOnset = row.ageAtOnset
      this.modifySampleList.diseaseDuration = row.diseaseDuration
      this.modifySampleList.familyHistory = row.familyHistory
      this.modifySampleList.medicationStatus = row.medicationStatus
      if (Array.isArray(row.groupList)) {
        this.modifySampleList.groupList = row.groupList
      } else if (row.groupList) {
        this.modifySampleList.groupList = [row.groupList]
      } else {
        this.modifySampleList.groupList = []
      }
      this.modifySampleList.fileId = row.fileId
      this.modifySampleList.userId = row.userId
      this.modifySampleList.nsfrtestDevice = row.NSFRTestDevice || row.nsfrTestDevice || row.nsfrtestDevice
      this.modifySampleList.nsfrtestDuration = row.NSFRTestDuration || row.nsfrTestDuration || row.nsfrtestDuration
    },
    async submitModifySample() {
      const payload = {
        ...this.modifySampleList,
        NSFRTestDate: this.modifySampleList.nsfrtestDate,
        NSFRScore: this.modifySampleList.nsfrscore,
        NSFRRisk: this.modifySampleList.nsfrrisk,
        NSFRTestDevice: this.modifySampleList.nsfrtestDevice,
        NSFRTestDuration: this.modifySampleList.nsfrtestDuration
      }
      const { data: res } = await this.$http.post('/brain/sample/modifySample', payload)
      if (res.code == 200) {
        this.editSampleDialogVisible = false
        this.$message({
          type: 'success',
          message: '修改样本信息成功!'
        })
        this.getSampleList()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.content {
  .top {
    display: flex;
    justify-content: space-between;
    .title {
      margin-left: 20px;
      .name {
        font-size: 30px;
        font-weight: 600;
      }
      .text {
        margin-top: 20px;
        font-size: 20px;
        color: #8e969e;
      }
    }
    .analyse {
      width: 39%;
      display: flex;
      background-color: #f8f0e5;
      border-radius: 10px;
      padding: 20px;
      .left {
        width: 50px;
        height: 50px;
        background-color: #f08a19;
        border-radius: 10%;
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
        .img {
          width: 50%;
        }
      }
      .right {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .title {
          font-weight: 600;
        }
        .text {
          font-size: 12px;
          color: #89909d;
        }
      }
    }
    .analyse2 {
      width: 39%;
      display: flex;
      background-color: #eff6ff;
      border-radius: 10px;
      padding: 20px;
      .left {
        width: 50px;
        height: 50px;
        background-color: #145fad;
        border-radius: 10%;
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
        .img {
          width: 50%;
        }
      }
      .right {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .title {
          font-weight: 600;
        }
        .text {
          font-size: 12px;
          color: #89909d;
        }
      }
    }
  }
  .box-card {
    margin-top: 20px;
    border-radius: 10px;
  }

  .empty-wrap {
    height: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    .text {
      margin-left: 8px;
    }
  }

  ::v-deep .el-table__empty-text {
    white-space: nowrap;
    text-align: center;
  }
  ::v-deep .el-table__empty-block {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .table-scroll {
    width: 100%;
    overflow-x: auto;

    ::v-deep .el-table th .cell,
    ::v-deep .el-table td .cell {
      white-space: nowrap;
    }
  }
}
</style>
